import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup,
  // Label,
  Row,
  Col,
} from 'reactstrap';
// import ButtonWithIcon from '../button-with-icon';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import PrimaryButtonWithIcon from '../primary-button-with-icon';

// import Button from '../button';
import Input from '../input';

const SearchOrderForm = (props) => {
  const {
    onSubmit,
    isLoading,
    t,
  } = props;
  const [orderNumber, setOrderNumber] = React.useState('');

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!executeRecaptcha) {
      console.warn('Recaptcha not yet available');
      return;
    }

    const token = await executeRecaptcha('search_order');

    onSubmit({ orderNumber, token });
  };

  const handleSetOrderNumber = (event) => setOrderNumber(_.get(event, 'target.value', ''));

  return (
    <div className="content-lg">
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Row style={{ paddingRight: '0px' }}>
            <Col className="colBlock" style={{ paddingLeft: 0 }}>
              <Input
                className="input-clean search-input"
                required
                type="text"
                name="orderNumber"
                id="orderNumber"
                value={orderNumber}
                onChange={handleSetOrderNumber}
                placeholder={t('orders.orderNumber')}
              />
            </Col>
            <Col className="colBlock" style={{ paddingRight: '0px', paddingLeft: '0px' }}>
              <div className="search-button">
                <PrimaryButtonWithIcon
                  disabled={_.isEmpty(orderNumber) || isLoading}
                  onClick={() => {}}
                  title={t('orders.findOne')}
                  width="230px"
                  height="44px"
                  icon="/assets/images/search-icon@2x.png"
                  type="submit"
                />
              </div>
            </Col>
          </Row>
        </FormGroup>
      </Form>
    </div>

  );
};

SearchOrderForm.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
SearchOrderForm.defaultProps = {
  isLoading: false,
};

export default SearchOrderForm;
